var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46349 16H18.5375C18.1955 15.411 18.0005 14.728 18.0005 14V9C18.0005 5.691 15.3085 3 12.0005 3C8.69149 3 6.00049 5.691 6.00049 9V14C6.00049 14.728 5.80449 15.411 5.46349 16ZM22.0005 18H2.00049C1.44749 18 1.00049 17.553 1.00049 17C1.00049 16.447 1.44749 16 2.00049 16C3.10349 16 4.00049 15.103 4.00049 14V9C4.00049 4.589 7.58849 1 12.0005 1C16.4115 1 20.0005 4.589 20.0005 9V14C20.0005 15.103 20.8975 16 22.0005 16C22.5525 16 23.0005 16.447 23.0005 17C23.0005 17.553 22.5525 18 22.0005 18ZM11.9945 22.995C11.4845 22.995 10.9675 22.865 10.4955 22.592C10.0435 22.329 9.66649 21.952 9.40449 21.501C9.12849 21.023 9.29149 20.411 9.76849 20.135C10.2485 19.856 10.8585 20.021 11.1355 20.499C11.2225 20.648 11.3475 20.774 11.4985 20.861C11.9755 21.14 12.5885 20.974 12.8655 20.498C13.1435 20.021 13.7555 19.859 14.2325 20.136C14.7105 20.413 14.8735 21.024 14.5945 21.502C14.0395 22.46 13.0305 22.995 11.9945 22.995Z",
    fill: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.18d9fe02.svg";
export { ForwardRef as ReactComponent };